export function loadStyles() {
  
    // Load default styles
    import("@/assets/css/feather.css");
    import("@/assets/css/custom.css");
  
}
